export class ObjectHelper {
    static values(object) {
        return Object.keys(object).map((key) => { return object[key]; });
    }
}
//# sourceMappingURL=../../src/lib/helper/object.js.map